module.exports = __webpack_public_path__ + "img/Service-Image.4b74b694.png";